import {Injectable} from '@angular/core';
import {FilterModel, MesApiService, Page, PagedData} from "common-shared";
import {instanceToInstance, plainToInstance} from "class-transformer";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

export class EventModel {
  Id: string;
  Category: string;
  Description: string;
  Level: number;
  Source: string;
  Content: string;
  CreatedBy: string;
  CreatedDate: Date;
}

export class EventFilterModel extends EventModel {
  ExpandContent: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class EventService extends MesApiService {
  iconsByLevel: string[] = ['#x-circle', '#x-circle', '#exclamation-circle', '#information-circle', '#information-circle'];
  colorsByLevel: string[] = ['text-danger', 'text-danger', 'text-warning', 'text-info', 'text-default']

  constructor() {
    super('Event');
  }

  getByFilter(filter: FilterModel<EventFilterModel>) {
    let clonedFilter = instanceToInstance(filter);
    return this.addGet<FilterModel<EventFilterModel>, PagedData<EventModel>>(clonedFilter, {action: 'GetByFilter'}).pipe(map(value1 => {
      return new PagedData<EventModel>(plainToInstance(EventModel, value1.data.Data), plainToInstance(Page, value1.data.Page));
    }));
  }

  loadOne(id: string): Observable<EventModel> {
    return this.getSingle<EventModel>({
      id: id
    }).pipe(map(value => {
      return plainToInstance(EventModel, value.data);
    }));
  }

  getConfigurationTimingData(batchCode: string): Observable<EventModel[]> {
    return this.getList<EventModel>({action: 'GetConfigurationTimingData'}, {batchCode: batchCode}).pipe(map(value => {
      return plainToInstance(EventModel, value.data);
    }));
  }
}
